import { createSlice } from '@reduxjs/toolkit';
import bridge from 'default/side-chat-bridge';

const initialState = {
  inputValue: '',
  isLoading: false,
  preview: null,
  showActions: false,
  showConversationsList: false,
  loadingConversations: false,
  pingPulse: false,
  status: null,
  streamingText: '',
  uploadingImage: false,
  pendingAttachments: [],
  showAttachmentPicker: false,
  feedbackMessageId: null,
  feedbackText: ''
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUi: (state, action) => {
      return { ...state, ...action.payload };
    },
    appendStreamingText: (state, action) => {
      state.streamingText += action.payload;
      state.isLoading = true;
    },
    resetStreamingUi: (state) => {
      state.isLoading = false;
      state.streamingText = '';
      state.status = null;
      state.uploadingImage = false;
      bridge.setStreaming(false);
    },
    resetUi: () => initialState,
    startStreaming: (state, action) => {
      state.inputValue = '';
      state.isLoading = true;
      state.streamingText = '';
      state.status = null;
      state.uploadingImage = false;
      state.pendingAttachments = [];
      if (action.payload?.showActions !== undefined) state.showActions = action.payload.showActions;
      bridge.setStreaming(true);
    },
    finishStreaming: (state) => {
      state.isLoading = false;
      state.streamingText = '';
      state.status = null;
      state.uploadingImage = false;
      state.showActions = true;
      bridge.setStreaming(false);
    },
    openConversationsList: (state) => {
      state.showConversationsList = true;
    },
    closeConversationsList: (state) => {
      state.showConversationsList = false;
      state.status = null;
    },
    startLoadingConversations: (state) => {
      state.loadingConversations = true;
    },
    finishLoadingConversations: (state) => {
      state.loadingConversations = false;
    },
    openFeedback: (state, action) => {
      state.feedbackMessageId = action.payload;
      state.feedbackText = '';
    },
    closeFeedback: (state) => {
      state.feedbackMessageId = null;
      state.feedbackText = '';
    },
    setFeedbackText: (state, action) => {
      state.feedbackText = action.payload;
    },
    appendPendingAttachment: (state, action) => {
      state.pendingAttachments = [...state.pendingAttachments, action.payload];
    }
  }
});

export const {
  setUi,
  appendStreamingText,
  resetStreamingUi,
  resetUi,
  startStreaming,
  finishStreaming,
  openConversationsList,
  closeConversationsList,
  startLoadingConversations,
  finishLoadingConversations,
  openFeedback,
  closeFeedback,
  setFeedbackText,
  appendPendingAttachment
} = uiSlice.actions;
export default uiSlice.reducer;
